import { render } from "./VisitingReservationForm.vue?vue&type=template&id=88e5d3bc"
import script from "./VisitingReservationForm.vue?vue&type=script&lang=js"
export * from "./VisitingReservationForm.vue?vue&type=script&lang=js"

import exportComponent from "/src/frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__